window.ATTR_CACHE_PROP = '__aframeAttrCache';

window.normalizeAttrValue = function normalizeAttrValue(value) {
    if (value === undefined) {
        return 'undefined';
    }
    if (value === null) {
        return 'null';
    }
    if (typeof value === 'object') {
        if (Array.isArray(value)) {
            return JSON.stringify(value.map(normalizeAttrValue));
        }
        const sortedKeys = Object.keys(value).sort();
        const normalizedObj = {};
        sortedKeys.forEach(key => {
            normalizedObj[key] = normalizeAttrValue(value[key]);
        });
        return JSON.stringify(normalizedObj);
    }
    return String(value);
};

window.setAttrIfChanged = function setAttrIfChanged(el, attr, value) {
    if (!el || typeof el.setAttribute !== 'function') {
        return false;
    }
    if (!el[window.ATTR_CACHE_PROP]) {
        Object.defineProperty(el, window.ATTR_CACHE_PROP, {
            value: {},
            configurable: false,
            enumerable: false,
            writable: true
        });
    }
    const normalized = window.normalizeAttrValue(value);
    if (el[window.ATTR_CACHE_PROP][attr] === normalized) {
        return false;
    }
    el[window.ATTR_CACHE_PROP][attr] = normalized;
    el.setAttribute(attr, value);
    return true;
};

window.removeAttrWithCache = function removeAttrWithCache(el, attr) {
    if (!el || typeof el.removeAttribute !== 'function') {
        return;
    }
    if (el[window.ATTR_CACHE_PROP]) {
        delete el[window.ATTR_CACHE_PROP][attr];
    }
    el.removeAttribute(attr);
};

window.applyTextureRepeatToMesh = function applyTextureRepeatToMesh(mesh, repeatX, repeatY) {
    if (!mesh) return false;
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    let updated = false;
    materials.forEach(mat => {
        if (mat && mat.map) {
            if (typeof THREE !== 'undefined') {
                mat.map.wrapS = THREE.RepeatWrapping;
                mat.map.wrapT = THREE.RepeatWrapping;
            }
            mat.map.repeat.set(repeatX, repeatY);
            mat.map.needsUpdate = true;
            updated = true;
        }
    });
    return updated;
};
